import { useEffect } from 'react';
import { useLocation } from 'react-router';

const Auto = ({ children }) => {

  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [location.pathname]);

  return (
    <>
      {children}
    </>
  );
};

const scroll = {
  Auto,
};

export default scroll;